module.exports = __webpack_public_path__ + "Loading_no-loop___2YouO.gif";